import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ApiServiceService} from '../api-service.service';
import {ConfirmPopUpSkeletonData} from './skeleton/confirm-pop-up-skeleton.component';

export interface ConfirmPopUpData extends ConfirmPopUpSkeletonData {
    message: string;
}

@Component({
    selector: 'app-comfirm-pop-up',
    templateUrl: 'confirm-pop-up.component.html',
    providers: [ApiServiceService]
})
export class ConfirmPopUpComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public popUpData: ConfirmPopUpData) {
    }
}
